import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { LocalizationPipe } from '@abp/ng.core';

@Component({
  standalone: true,
  selector: 'custom-error',
  templateUrl: './custom-error-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LocalizationPipe],
})
export class CustomErrorComponent {
  constructor(private readonly _location: Location) {}

  errorStatus: string;

  backClicked() {
    this._location.back();
  }
}
